export default __webpack_public_path__ + "static/O0071-c9653956522d7ad15753174f0000d921.png";